import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { AlertService } from '../shared/alerts/alerts.service';
import { LoadingService } from '../shared/loading/loading.service';
import * as _ from 'lodash';

@Component({
    selector: 'bxb-tenant',
    template: require('./tenant.component.html'),
    styles: [require('./tenant.component.scss')],
})

export class TenantComponent implements OnInit {
    public tenantList: string[];
    public defaultTenant: string;
    public selectedTenant: string;
    public pageLoaded: boolean;

    constructor(private authService: AuthService,
                private router: Router,
                private alertService: AlertService,
                private loadingService: LoadingService) {
        this.tenantList = [];
    }

    logoutUser() {
        this.loadingService.showLoading();

        this.authService.logoutUser()
          .subscribe(() => {
              this.authService.logout();
          }, () => {}, () => { this.loadingService.hideLoading(); });
    }

    checkUserPreference(preferenceName) {
      this.authService.getUserPreference(preferenceName)
        .subscribe((data) => {
          if ( Object.keys(data).length ) {
            const { path, subPath, qParams } = data;
            this.authService.gotoUserPreferredApp(path, subPath, qParams);
          } else {
            this.authService.gotoHome();
          }
        }, (err) => {
            err.status === 404 ? this.authService.gotoHome() :
            this.alertService.createAlert(true, true, 'Error occurred while fetching preference.');
        });
    }

    onTenantSelect() {
        const tenant = this.selectedTenant ? this.selectedTenant : this.defaultTenant;

        this.authService.updateTenant({ tenant: tenant })
            .subscribe(() => {
              this.checkUserPreference('preferredApp');
            }, () => {
                this.alertService.createAlert(true, true, 'Error occurred while switching tenant.');
            });
    }

    getTenantList() {
        this.loadingService.showLoading();
        this.pageLoaded = false;

        this.authService.getTenants()
            .subscribe((data) => {
                this.tenantList = _.get(data, 'tenants', []).map(
                  tenant => tenant.organization.toLocaleLowerCase().includes('admin') ?
                    { ...tenant, label: 'ADMIN' } : { ...tenant, label: tenant.organization }
                );

                // TO DO  need to revert once the default tenant is implemented.
                this.defaultTenant = '';

                if ( this.tenantList.length === 1 ) {
                  this.checkUserPreference('preferredApp');
                }

                this.pageLoaded = true;
            }, () => {
                this.router.navigate(['/login']);
            }, () => {
                this.loadingService.hideLoading();
            });
    }

    ngOnInit() {
        this.getTenantList();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/tenant/tenant.component.ts